import React, { Component } from "react";

import { CCard, CCardBody, CBadge, CCardFooter, CButton } from "@coreui/react";
import { FaHome } from "react-icons/fa";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

import "./style.css";

class NotificationMe extends Component {
  constructor(props) {
    super(props);
    this.state = {
      notices: [],
      occurrences: [],
      list: [],
      loading: true
    };
  }

  friendlyDate(date) {
    const dt = new Date(date);
    const hj = new Date();
    const months = [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro"
    ];

    if (dt.getFullYear() !== hj.getFullYear()) {
      return `${dt.getDate()} de ${
        months[dt.getMonth()]
      } de ${dt.getFullYear()}`;
    }

    return `${dt.getDate()} de ${
      months[dt.getMonth()]
    }, às ${`00${dt.getHours()}`.slice(-2)}:${`00${dt.getMinutes()}`.slice(
      -2
    )}`;
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Fail", response);
    }
  }

  mergeGroups() {
    let arr1 = this.state.notices;
    let arr2 = this.state.occurrences;
    let list = [];

    // inicializa com os meses necessários
    arr1.filter(item => {
      let obj = {
        group: item.group,
        data: []
      };
      list.push(obj);
    });

    arr2.filter(item => {
      let obj = {
        group: item.group,
        data: []
      };
      list.push(obj);
    });

    // tira repetidos
    list = list.filter(
      a => !this[JSON.stringify(a)] && (this[JSON.stringify(a)] = true),
      Object.create(null)
    );

    // coloca os datas do arr1 no list
    arr1.forEach(item => {
      for (let i = 0; i < list.length; i++) {
        if (item.group === list[i].group) {
          list[i].data = [...item.data, ...list[i].data];
        }
      }
    });

    // coloca os datas do arr2 no list
    arr2.forEach(item => {
      for (let i = 0; i < list.length; i++) {
        if (item.group === list[i].group) {
          list[i].data = [...item.data, ...list[i].data];
        }
      }
    });

    this.setState({ list, loading: false });
  }

  group(myArray) {
    let months = [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro"
    ];

    let groups = myArray.reduce((r, o) => {
      let m = o.created_at?.split("-")[1];
      let y = o.created_at?.split("-")[0];

      let extra = parseInt(y) !== new Date().getFullYear() ? ` de ${y}` : "";

      r[`${m}-${y}`]
        ? r[`${m}-${y}`].data.push(o)
        : (r[`${m}-${y}`] = {
            group: months[parseInt(m) - 1] + extra,
            data: [o]
          });

      return r;
    }, {});

    let result = Object.keys(groups).map(k => groups[k]);

    return result;
  }

  getDescription(description) {
    try {
      let result = JSON.parse(description)[0].children[0].text;
      return result;
    } catch {
      return description;
    }
  }

  componentDidMount() {
    // Puxando informações de Notices
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    const obj = {
      user_id: this.props.user.user.id,
      role_id: this.props.general.active_roles.role_id,
      not_created_by: this.props.user.user.id
    };

    // Puxando informações de Occurrences
    const params = {
      for: this.props.user.user.id
    };

    axios
      .post(`${URL.api}communication/notice/list`, obj, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        respNotices => {
          axios
            .get(`${URL.api}communication/occurrence/list`, {
              params,
              headers: { authorization: `Bearer ${this.props.user.token}` }
            })
            .then(
              respOccurrences => {
                this.setState(
                  {
                    occurrences: this.group(respOccurrences.data.data),
                    notices: this.group(respNotices.data.data)
                  },
                  () => this.mergeGroups()
                );
              },
              error => {
                this.error(error.response.statusText);
              }
            );
        },
        error => {
          this.error(error.response.statusText);
        }
      );

    // axios
    //   .get(`${URL.api}communication/occurrence/list`, {
    //     params,
    //     headers: { authorization: `Bearer ${this.props.user.token}` }console
    //   })
    //   .then(resp => {
    //     this.setState({
    //       occurrences: this.group(resp.data.data),
    //       loading: false
    //     });
    //   });
  }

  render() {
    // eslint-disable-next-line prefer-template
    const InicioString = URL.public + "uploads/activity/";

    return (
      <>
        {["G", "U", "R", "E", "P"].includes(
          this.props.general.active_roles.type
        ) && (
          <>
            <div className="botoes">
              <div className="d-flex">
                <div className="flex-1 d-flex justify-content-end align-items-center">
                  <Breadcrumb current={this.props.currentRoute} />
                  <div className="flex-1 d-flex justify-content-end align-items-center">
                    <CButton
                      color="primary"
                      onClick={() => this.props.history.push("/notice/form")}
                      style={{ minWidth: "180px" }}
                    >
                      <i className="fa fa-plus mr-2"></i>Novo Aviso
                    </CButton>
                  </div>
                  {["G", "E", "R", "U", "E2", "P"].includes(
                    this.props.general.active_roles.type
                  ) && (
                    <div className="flex-1 d-flex justify-content-end align-items-center">
                      <CButton
                        color="primary"
                        onClick={() =>
                          this.props.history.push("/occurrence/form")
                        }
                        style={{ minWidth: "180px", marginLeft: "10px" }}
                      >
                        <i className="fa fa-plus mr-2"></i>Nova Ocorrência
                      </CButton>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <hr className="mt-1 mb-4" />
          </>
        )}
        {this.state.loading ? (
          <Loading />
        ) : this.state.list.length > 0 ? (
          this.state.list.map(month => (
            <>
              <h4 className="mb-4">{month.group}</h4>
              <div className="card-columns mb-4">
                {month.data.map(notice => (
                  // <CLink
                  //   to={notice.room_id ? `/classroom/${notice.room_id}` : "#"}
                  //   key={notice.id}
                  //   className="not-link"
                  // >
                  <CCard
                    key={notice.id}
                    className="notice-card"
                    onClick={() => {
                      if (notice.title) {
                        this.props.history.push(`/notice/details/${notice.id}`);
                      } else {
                        this.props.history.push(
                          `/occurrence/details/${notice.id}`
                        );
                      }
                    }}
                  >
                    <CCardBody>
                      <div>
                        <div className="d-flex align-items-center">
                          {notice.title ? (
                            <div className="c-avatar mr-2">
                              <img
                                className="c-avatar-img"
                                alt=""
                                src={
                                  URL.img +
                                  (notice.user_photo ||
                                    "uploads/users/profileEmpty.jpg")
                                }
                              />
                            </div>
                          ) : (
                            ""
                          )}

                          <div className="d-block w-100">
                            <div className="d-flex">
                              <span className="d-flex" style={{ flex: 1 }}>
                                {notice.user_name
                                  ? notice.user_name
                                  : "Ocorrência"}
                              </span>
                            </div>
                            <div className="text-muted">
                              {this.friendlyDate(notice.created_at)}
                            </div>
                          </div>
                        </div>
                        <div
                          className="mt-2"
                          style={{ fontSize: "1rem", fontWeight: "bold" }}
                        >
                          {notice.title ? notice.title : notice.description}
                        </div>
                      </div>
                      {notice.description && (
                        <div className="mt-2">
                          {this.getDescription(notice.description)}
                        </div>
                      )}{" "}
                    </CCardBody>
                    {/* {(notice.docs.length > 0 ||
                      notice.activities.length > 0 ||
                      notice.uploads.length > 0) && (
                      <CCardFooter className="justify-content-start">
                        {notice.activities.map(activity => (
                          <CBadge
                            color={
                              activity.type_id === 2 ? "danger" : "primary"
                            }
                            className={`mfe-2 p-2 cursor btn-${
                              activity.type_id === 2 ? "danger" : "primary"
                            }`}
                            to={`/activity/${
                              activity.type_id === 2 ? "live" : "do"
                            }/${activity.allocation_id}`}
                            target={activity.type_id === 2 ? "_blank" : null}
                          >
                            <i
                              className={`fa fa-${
                                activity.type_id === 2
                                  ? "circle"
                                  : "check-square"
                              } mr-2`}
                            ></i>
                            {activity.name}
                          </CBadge>
                        ))}
                        {notice.docs.map(doc => (
                          <CBadge
                            color="light"
                            className="mfe-2 p-2 cursor btn-light"
                            to={
                              notice.room_id
                                ? `/classroom/${notice.room_id}/docs`
                                : "/docs/me"
                            }
                          >
                            <i className="fa fa-file mr-2"></i>
                            {doc.name}
                          </CBadge>
                        ))}
                        {notice.uploads.map(doc => (
                          <CBadge
                            color="light"
                            className="mfe-2 p-2 cursor btn-light"
                            to={
                              notice.room_id
                                ? `/classroom/${notice.room_id}/docs`
                                : "/docs/me"
                            }
                          >
                            <i className="fa fa-file mr-2"></i>
                            {doc.file.replace(InicioString, "")}
                          </CBadge>
                        ))}
                      </CCardFooter>
                    )} */}
                    {notice.uploads.length > 0 && (
                      <CCardFooter className="justify-content-start text-ellipsis">
                        {notice.uploads.map(doc => (
                          <CBadge
                            color="light"
                            className="mfe-2 p-2 cursor btn-light"
                            to={
                              notice.room_id
                                ? `/classroom/${notice.room_id}/docs`
                                : "/docs/me"
                            }
                          >
                            <i className="fa fa-file mr-2"></i>
                            {doc.file.replace(InicioString, "")}
                          </CBadge>
                        ))}
                      </CCardFooter>
                    )}
                  </CCard>
                  // </CLink>
                ))}
              </div>
            </>
          ))
        ) : (
          <div className="d-flex flex-column h-100 align-items-center justify-content-center m-3">
            <h3 className="display-7">
              Você ainda não possui nenhuma notificação.
            </h3>
            <CButton className="mt-4" color="primary" to="/">
              <FaHome /> Voltar para a página principal
            </CButton>
          </div>
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(NotificationMe);
